<template>
  <div class="form-group lm-select" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      v-if="label"
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
      />
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <select
        :value="modelValue"
        @input="onInput"
        :class="{'is-invalid': v.$error}"
        :disabled="disabled"
        class="form-control"
        :id="idComputed"
        >
        <option v-if="options.disabledOption" disabled :value="null">
          {{ options.disabledOption }}
        </option>

        <option
          v-for="(option, index) of options.content"
          :key="index"
          :value="option.value || option"
        >
          {{ option.text || option }}
        </option>

      </select>
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    options: {
      type: Object,
      required: true
    },
    returnObjectIdName: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue () {
      return this.returnObjectIdName ? this.value?.id : this.value
    }
  },
  methods: {
    onInput (event) {
      let data = event.target.value
      if (this.returnObjectIdName) {
        const option = this.options.content.find(el => el.value === event.target.value)
        data = {
          id: event.target.value,
          name: option.text
        }
      }
      this.$emit('input', data)
    }
  }
}
</script>
